import React, { useState, useEffect } from "react";
import HeadLines from "../HeadLines";
import style from "./style.module.css";
import "../../commonStyle.css";
import BlurModal from "../BlurModal/BlurModal";
import BlurModalHeading from "../BlurModal/BlurModalHeading";
import BlurModalContent from "../BlurModal/BlurModalContent";
import InputFieldWithTitle from "../InputFieldWithTitle/InputFieldWithTitle";
import { dcrossIcon } from "../../icon_assets";
import { isMobile } from "../../helperFunc";

const LocationFilter = (props) => {
  const {
    show,
    setShow,
    location,
    setLocation,
    cityList = [],
    setCityId = 0,
    setLocationLang,
    mandiBhavPage,
  } = props;
  const [search, setSearch] = useState("");
  const [states, setStates] = useState([]);

  useEffect(() => {
    if (mandiBhavPage) setStates(cityList?.slice());
    else setStates(cityList?.slice(Math.max(cityList.length - 5, 0)));
  }, [cityList]);

  useEffect(() => {
    if (search === "") {
      if (mandiBhavPage) setStates(cityList?.slice());
      else setStates(cityList?.slice(Math.max(cityList.length - 5, 0)));
    } else {
      setStates(
        cityList?.filter((arr) =>
          arr.city_name.toLowerCase().includes(search.toLowerCase())
        )
      );
    }
  }, [search]);

  return (
    <BlurModal
      className={`blur-modal ${style["location-modal"]}`}
      show={show}
      onHide={() => setShow(false)}
    >
      <>
        <BlurModalHeading
          className={`padding-left16
                        padding-bottom16
                        ${
                          !isMobile &&
                          `backAccent9 borderRadiusTop d-flex justify-content-between padding-right16`
                        }
                       `}
          heading={
            <>
              <HeadLines
                className={`font-weight600 
              ${
                !isMobile
                  ? `font-size20 line-height23`
                  : `font-size18 line-height21`
              } 
                            `}
                text={"Select City"}
              />
              {!isMobile && (
                <div
                  onClick={() => {
                    setShow(false);
                  }}
                  className="cursorPointer"
                >
                  {" "}
                  <img src={dcrossIcon} alt="" />
                </div>
              )}
            </>
          }
        />
        <BlurModalContent className={"margin16 padding-bottom16 "}>
          <InputFieldWithTitle
            placeholder={"Search City..."}
            inputClassName={`${isMobile && style["inputBackColor"]} ${
              style["inputBorder"]
            } width-100 height-40p padding12 ${!isMobile && `font-size16`}`}
            className={`mb-0`}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            // disabled={false}
          />
          {states?.length > 0 ? (
            <>
              <div className={mandiBhavPage ? style["scrollVertical"] : ""}>
                {states?.map((item, index) => {
                  return (
                    <div
                      className={` font-weight500 ${
                        !isMobile ? `font-size16` : `font-size14`
                      } line-height16 letterSpacing05  padding-top16
                      } padding-bottom8 d-flex align-items-center justify-content-between cursorPointer`}
                      onClick={() => {
                        setSearch("");
                        setLocation(item.city_name);
                        setCityId(item.city_id);
                        setLocationLang(item.city_lang);
                      }}
                    >
                      <HeadLines
                        text={item.city_lang}
                        className={
                          location === item.city_name &&
                          "font-weight600 colorDark3"
                        }
                      />
                      {location === item.city_name && (
                        <div className={style["dotColor"]}></div>
                      )}
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            ""
          )}
        </BlurModalContent>
      </>
    </BlurModal>
  );
};

export default LocationFilter;
